module.exports = __webpack_public_path__ + "static/media/misscacao.b56bffcd.jpeg";